module.exports = __webpack_public_path__ + "img/18.b8e1ba36.jpg";